import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigsService } from '../providers/configs.service';
import { SessionService } from '../providers/session.service';


@Injectable()
export class ClienteService {

    constructor(
        public http: HttpClient,
        public session: SessionService,
        public configs: ConfigsService
    ) { }

    getCliente(cod_cliente, razao_social){
        cod_cliente = (cod_cliente == null || cod_cliente == '') ? '' : '&cod_cliente=' + cod_cliente
        razao_social = (razao_social == null || razao_social == '') ? '' : '&razao_social=' + razao_social

        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'clientes?' + cod_cliente + razao_social)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                })
        })
    }


    salvarCliente(cliente) {
        return new Promise((resolve, reject) => {
            let body = cliente;
            console.log("cliente service", body)
            this.http.post(this.configs.getEndpoint() + 'clientes', body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        })
    }

    getClientesByID(id) {
        console.log("get by id", id)
        return new Promise((resolve, reject) => {
            this.http.get(this.configs.getEndpoint() + 'clientes/' + id)
                .subscribe(data => {
                    
                    resolve(data);
                    
                },
                error => {
                    reject(error);
                });
        });
    }

    putCliente(cliente){
        return new Promise((resolve, reject) => {
            let body = cliente;
            this.http.put(this.configs.getEndpoint() + 'clientes/' + cliente['id'], body)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error);
                });
        });
    }

    deleteCliente(id) {
        return new Promise((resolve, reject) => {
            this.http.delete(this.configs.getEndpoint() + 'clientes/' + id)
                .subscribe(data => {
                    resolve(data);
                },
                error => {
                    reject(error)
                });
        });
    }

}

//     getTipoConducaoLista() {
//         return new Promise(resolve => {
//             this.http.get(this.configs.getEndpoint() + '/funcionarios/listaTiposConducao')
//                 .subscribe(data => {
//                     resolve(data.json()['data']);
//                 });
//         });
//     }
//     getTipoSanguineoLista() {
//         return new Promise(resolve => {
//             this.http.get(this.configs.getEndpoint() + '/funcionarios/listaTiposSanguineos')
//                 .subscribe(data => {
//                     resolve(data.json()['data']);
//                 });
//         });
//     }
//     getFuncionarios() {
//         return new Promise(resolve => {
//             let token
//             this.session.getSessao(null).then(res => {
//                 token = res['token']
//                 console.log(token);

//                 let headers = new Headers;

//                 headers.append('Content-Type', 'application/json')
//                 headers.append('Authorization', 'Bearer ' + token)

//                 let options = new RequestOptions({ headers: headers });
//                 this.http.get(this.configs.getEndpoint() + '/funcionarios', options)
//                     .subscribe(data => {
//                         resolve(data.json());
//                     });
//             });
//         });
//     }

//     getFuncionario(matricula, nome_guerra, cpf) {
//         matricula = (matricula == null || matricula == '') ? '' : '&matricula=' + matricula
//         nome_guerra = (nome_guerra == null || nome_guerra == '') ? '' : '&nome_guerra=' + nome_guerra
//         cpf = (cpf == null || cpf == '') ? '' : '&cpf=' + cpf
//         return new Promise(resolve => {
//             let token
//             this.session.getSessao(null).then(res => {
//                 token = res['token']
//                 console.log(token);

//                 let headers = new Headers;

//                 headers.append('Content-Type', 'application/json')
//                 headers.append('Authorization', 'Bearer ' + token)

//                 let options = new RequestOptions({ headers: headers });
//                 this.http.get(this.configs.getEndpoint() + '/funcionarios?' + matricula + nome_guerra + cpf, options)
//                     .subscribe(data => {
//                             resolve(data.json());
//                     });
//             });
//         });
//     }

//     getFuncionariosByID(id) {
//         return new Promise(resolve => {
//             let token
//             this.session.getSessao(null).then(res => {
//                 token = res['token']
//                 console.log(token);

//                 let headers = new Headers;
//                 let body = id;

//                 headers.append('Content-Type', 'application/json')
//                 headers.append('Authorization', 'Bearer ' + token)

//                 let options = new RequestOptions({ headers: headers });
//                 this.http.get(this.configs.getEndpoint() + '/funcionarios/' + id, options)
//                     .subscribe(data => {
//                         resolve(data.json());
//                     });
//             });
//         });
//     }

//     putFuncionarios(funcionario) {
//         return new Promise(resolve => {
//             let token
//             this.session.getSessao(null).then(res => {
//                 token = res['token']
//                 console.log(token);

//                 let headers = new Headers;
//                 let body = funcionario;

//                 headers.append('Content-Type', 'application/json')
//                 headers.append('Authorization', 'Bearer ' + token)

//                 let options = new RequestOptions({ headers: headers });
//                 this.http.put(this.configs.getEndpoint() + '/funcionarios/' +funcionario['id'], body, options)
//                     .subscribe(data => {
//                         resolve(data.json());
//                     });
//             });
//         });
//     }

// }
